import Checkbox from "./Checkbox";
import TextInputField from "./InputField";
import EmailField from "./ReadyMade/EmailField";
import PasswordField from "./ReadyMade/PasswordField";
import RepeatPasswordField from "./ReadyMade/RepeatPasswordField";
import FormRoot from "./Root";
import Submit from "./Submit";

const Form = {
  Root: FormRoot,
  TextInputField,
  Checkbox,
  Submit,
  // readymade below
  PasswordField,
  RepeatPasswordField,
  EmailField,
};

export default Form;
